export const slugTurkish = text => {
  var trMap = {
    çÇ: 'c',
    ğĞ: 'g',
    şŞ: 's',
    üÜ: 'u',
    ıİ: 'i',
    öÖ: 'o'
  };
  for (var key in trMap) {
    text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
  }
  return  text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
    .replace(/\s/gi, '-')
    .replace(/[-]+/gi, '-')
    .toLowerCase();
};

export const unslugTurkish = slug => {
  var trMap = {
    c: /ç/g,
    g: /[ğg]/g,
    s: /[şs]/g,
    u: /[üu]/g,
    i: /[ıi]/g,
    o: /[öo]/g
  };
  slug = slug.replace(/[-]+/gi, ' ').toLowerCase();
  for (var key in trMap) {
    slug = slug.replace(trMap[key], key);
  }
  return slug.replace(/\b\w/g, c => c.toUpperCase());
};